<div class="modal add-user-modal">
  <div class="modal-dialog modal-dialog-scrollable user-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'user.add.addbtn' | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()" tabindex="0"
          (keydown.enter)="close()"></button>
      </div>
      <div class="modal-body">
        <form class="add-user-form" [formGroup]="addUserForm">
          <div class="input-container mb-3">
            <label for="inputUsername"><span class="required">*</span>{{ 'user.add.userName' | translate }}</label>
            <input type="text" id="inputUsername" formControlName="Username" />
            <span class="error-text">{{ addUserFormErrors.Username }}</span>
          </div>
          <div class="input-container">
            <label><span class="required">*</span> {{ 'user.add.authenticationType' | translate }}</label>
            <div class="custom-toggle-container">
              <label for="basicAuth">

                <span class="material-symbols-outlined">
                  &#xe86c;
                </span>
                {{ 'user.add.basicAuth' | translate }}
                <input type="checkbox" id="basicAuth" formControlName="BasicAuth" (click)="checkAuthenticationType()"
                  tabindex="0" (keydown.enter)="checkAuthenticationType()">
              </label>
              <label for="apiKey">
                <span class="material-symbols-outlined">
                  &#xf64c;
                </span>
                {{ 'user.add.apiKey' | translate }}
                <input type="checkbox" id="apiKey" formControlName="APIKey" (click)="checkAuthenticationType()"
                  tabindex="0" (keydown.enter)="checkAuthenticationType()">
              </label>
            </div>
          </div>
          @if (this.addUserForm.value.BasicAuth) {
          <div class="input-row">
            <div class="input-container">
              <label for="inputFirstName">
                <span class="required">*</span> {{ 'user.add.firstName' | translate }}
              </label>
              <input type="text" id="inputFirstName" formControlName="FirstName" />
              <span class="error-text">{{ addUserFormErrors.FirstName }}</span>
            </div>
            <div class="input-container">
              <label for="input-name"><span class="required">*</span> {{ 'user.add.lastName' | translate }}</label>
              <input type="text" id="input-name" formControlName="LastName" />
              <span class="error-text">{{ addUserFormErrors.LastName }}</span>
            </div>
          </div> }
          <div class="input-row">
            @if (this.addUserForm.value.BasicAuth) {
            <div class="input-container">
              <label for="inputPhone">
                <span class="required me-1">*</span>{{ 'user.add.phone' | translate }}
              </label>
              <input #inputPhone type="text" id="inputPhone" mask="(000) 000-0000" unmask="true" [validation]="false"
                formControlName="Phone" (input)="onInput($event)" />
              <span class="error-text">{{ addUserFormErrors.Phone }}</span>
            </div> }
            <div class="input-container">
              <label for="inputEmail">
                <span class="required">*</span> {{ 'user.add.email' | translate }}
              </label>
              <input type="text" id="inputEmail" formControlName="Email" />
              <span class="error-text">{{ addUserFormErrors.Email }}</span>
            </div>
          </div>
          @if (!this.addUserForm.value.APIKey || this.addUserForm.value.BasicAuth) {
          <div ngbAccordion #acc="ngbAccordion" activeIds="toggle-basics">
            <div ngbAccordionItem id="toggle-address">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton>
                  {{ 'user.add.addressDetails' | translate }}
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-container formGroupName="address">
                    <div class="input-container mb-3">
                      <label for="inputAddressLine1">
                        {{ 'user.add.addressLine1' | translate }}
                      </label>
                      <input type="text" id="inputAddressLine1" formControlName="AddressLine1" />
                      <span class="error-text">{{ addUserFormErrors.AddressLine1 }}</span>
                    </div>
                    <div class="input-container">
                      <label for="inputAddressLine2">
                        {{ 'user.add.addressLine2' | translate }}
                      </label>
                      <input type="text" id="inputAddressLine2" formControlName="AddressLine2" />
                      <span class="error-text">{{ addUserFormErrors.AddressLine2 }}</span>
                    </div>

                    <div class="input-row">
                      <div class="input-container">
                        <label for="inputCity">
                          {{ 'user.add.city' | translate }}
                        </label>
                        <input type="text" id="inputCity" formControlName="City"
                          (keypress)="omit_numeric_special_char($event)" />
                        <span class="error-text">{{ addUserFormErrors.City }}</span>
                      </div>
                      <div class="input-container">
                        <label for="inputState">
                          {{ 'user.add.state' | translate }}
                        </label>
                        <select id="inputState" class="form-select" formControlName="State" aria-label="Select State">
                          @for (o of stateList; track o) {
                          <option [value]="o?.abbreviation">{{o?.name}}</option> }
                        </select>
                        <span class="error-text">{{ addUserFormErrors.State }}</span>
                      </div>
                    </div>

                    <div class="input-row">
                      <div class="input-container">
                        <label for="inputPostalCode">{{ 'user.add.postalCode' | translate }}</label>
                        <input type="text" id="inputPostalCode" [mask]="postalCodeMask" unmask="true"
                          [validation]="false" (keyup)="validatePostalCode($event)" formControlName="PostalCode" />
                        <span class="error-text">{{ addUserFormErrors.PostalCode }}</span>
                      </div>
                      <div class="input-container">
                        <label for="inputCountry">{{ 'user.add.country' | translate }}</label>
                        <select id="inputCountry" class="form-select" formControlName="Country" aria-label="USA">
                          @for (option of countryList || []; track option) {
                          <option [value]="option.id">{{option.name}}</option> }
                        </select>
                        <span class="error-text">{{ addUserFormErrors.Country }}</span>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </div> }
        </form>
      </div>

      <div class="modal-footer">
        <a role="button" class="button button-clear" aria-label="Close" (click)="close()" tabindex="0"
          (keydown.enter)="close()">{{ "common.cancel" | translate }}</a>
        <a role="button" class="button button-pink" [ngStyle]="{ 'pointer-events': isLoader_AddUser() ? 'none' : '' }"
          (click)="addUser()" tabindex="0" (keydown.enter)="addUser()">
          <span>
            @if (isLoader_AddUser()) {
            <span class="spinner-border spinner-border-sm"></span>
            }
            <span class="m-3">{{ "common.save" | translate }}</span>
          </span></a>
      </div>
    </div>
  </div>
</div>